"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSocialYoutube = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconSocialYoutube = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M12.036 4h.048l.368.002c1.656.01 7.333.073 8.925.5a3.036 3.036 0 0 1 2.126 2.151c.459 1.72.494 5.139.497 5.746v.187c-.004.608-.046 4.033-.504 5.753a3.049 3.049 0 0 1-2.126 2.151c-.796.217-2.612.342-4.436.413l-.546.02a148.06 148.06 0 0 1-4.153.076h-.478a146.68 146.68 0 0 1-4.152-.075l-.546-.02c-1.823-.07-3.637-.193-4.43-.407a3.036 3.036 0 0 1-2.126-2.15C.06 16.683.007 13.427 0 12.662v-.327c.006-.764.06-4.02.496-5.683A3.026 3.026 0 0 1 2.622 4.51c.796-.217 2.612-.342 4.436-.413l.546-.02a143.21 143.21 0 0 1 3.936-.075L11.908 4h.128ZM9.592 8.856v7.288L15.84 12.5 9.592 8.856Z"
}));
exports.IconSocialYoutube = IconSocialYoutube;
//# sourceMappingURL=IconSocialYoutube.js.map